<template>
  <div class="wireUseInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      線材使用資訊
    </li>
    <b-table
      :items="wireUseInformationItem"
      :fields="wireUseInformationFields"
      class="text-center wireUseInformation-table-detail wireUseInformation-table-detail-last"
    >
      <template v-slot:cell(index)="data">{{
        data.index + 1 != wireUseInformationItem.length ? data.index + 1 : ""
      }}</template>
      <template #cell(consumption)="data" style="">
        {{ data.value.toLocaleString("en-US") }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "wireUseInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      wireUseInformationFields:
        "wireUseInformation/get_wireUseInformationFields",
      wireUseInformationItem: "wireUseInformation/get_wireUseInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.wireUseInformation-table-detail thead th {
  border-top: 1px solid;
}
.wireUseInformation-table-detail th,
.wireUseInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle!important;
}
.wireUseInformation-table-detail th:first-child,
.wireUseInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.wireUseInformation-table-detail {
  margin-bottom: 0px;
}
.wireUseInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(1) {
  background-color: transparent;
  border-color: transparent !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(2) {
  background-color: transparent;
  border-color: transparent !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(3) {
  background-color: transparent;
  border-color: transparent !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(4) {
  background-color: transparent;
  border-color: transparent !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(5) {
  background-color: transparent;
  border-color: transparent !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(6) {
  background-color: transparent;
  border-top: 1px transparent solid !important;
  border-left: 1px transparent solid !important;
  border-bottom: 1px transparent solid !important;
  border-right: 2px #c10000 solid !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(7) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
}
.wireUseInformation-table-detail-last tr:last-child td:nth-child(8) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
  border-right: 2px #c10000 solid !important;
}
// .wireUseInformation-table-detail-last tr:last-child td:nth-child(9) {
//   border-bottom: 2px #c10000 solid !important;
//   border-top: 2px #c10000 solid !important;
//   border-right: 2px #c10000 solid !important;
// }
.wireUseInformation-table-detail tr td {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/wireUseInformation.vue